
import { defineComponent } from 'vue'
import AlertIcon from '@/components/vectors/AlertIcon.vue'

export default defineComponent({
  components: { AlertIcon },
  props: { message: String, buttonText: String, buttonFunction: Function }
})
